import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'src/app/models/entry';
import { EntryService } from 'src/app/services/entry.service';

@Component({
    selector: 'app-entry',
    templateUrl: './entry.component.html',
    styleUrls: ['./entry.component.scss'],
    standalone: false
})
export class EntryComponent implements OnInit {

  entry: any;
  constructor(
    private _route: ActivatedRoute,
    private _entryService: EntryService,
  ) { }

  async ngOnInit(): Promise<void> {
    const id = this._route.snapshot.paramMap.get('id');
    this.entry = Object.assign(new Entry, (await this._entryService.get(id)).data());
  }

}
